import styled from 'styled-components';
import colors from '../../../../../../includes/colors';

export const Title = styled.h3`
  color: ${colors.black};
  line-height: 1.5rem;
  font-weight: 300;
  font-size: 1.0625rem;
  @media (min-width: 576px) {
    font-size: 1.25rem;
  }
`;
